import * as React from 'react';
import { useGetRolePermissionQuery } from "../../../apis/RolePermission.api";
import { PrimaryRolePermission, RolePermission } from "../../../types/models/RolePermission";
import RoleName from "../../../../auth/components/role/RoleDetail/RoleName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: RolePermission;
};

export const RolePermissionNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><RoleName id={ data?.roleId }/>
                    {data?.permission && <> | </> }{ data?.permission }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const RolePermissionName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetRolePermissionQuery(PrimaryRolePermission.fromId(id))
    return (<RolePermissionNameDisplay data={data}/>)
}

export default RolePermissionName;
